/**
 * en / fr / es strings of the local cart toasts in `NotificationPopup.tsx`. Only
 * `AddToCartNotification` and `RemoveFromCartNotification` there read them, and neither has an
 * importer; the live toasts take their strings from `@ryerson/frontend.application`
 * (`dist/Notification/NotificationContent`).
 */
import { LanguageContent } from "@ryerson/frontend.common";

/** Toast labels. `priceShownInCart` has no reader. */
export interface NotificationProps {
	addTitle: string;
	removeTitle: string;
	product: string;
	alt: string;
	leadTime: string;
	extendedPrice: string;
	qty: string;
	undo: string;
	priceShownInCart: string;
	priceInCart: string;
}

/** Strings by language; readers fall back to `en`. */
export const NotificationContent: LanguageContent<NotificationProps> = {
	en: {
		addTitle: "Added to Cart",
		removeTitle: "Removed from Cart",
		product: "product",
		alt: "ALT: ",
		leadTime: "Lead Time: ",
		extendedPrice: "Extended Price",
		qty: "Qty: ",
		undo: "Undo",
		priceShownInCart: "Price shown in cart",
		priceInCart: "In cart",
	},
	fr: {
		addTitle: "L’article a été ajouté au panier",
		removeTitle: "L’article a été supprimé du panier",
		product: "Produit",
		alt: "ALT:",
		leadTime: "Délai de production :",
		extendedPrice: "Prix calculé",
		qty: "Qté :",
		undo: "Annuler",
		priceShownInCart: "Le prix est affiché dans le panier",
		priceInCart: "Dans le panier",
	},
	es: {
		addTitle: "Agregado al carrito",
		removeTitle: "Removido del carrito",
		product: "Producto",
		alt: "ALT:",
		leadTime: "Tiempo de espera:",
		extendedPrice: "Precio extendido",
		qty: "Cantidad:",
		undo: "Deshacer",
		priceShownInCart: "Precio mostrado en el carrito",
		priceInCart: "En el carrito",
	},
};
